import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, TrendingUp, Compass, Shield } from 'lucide-react';
export function ThoughtLeadership() {
  const articles = [{
    icon: TrendingUp,
    category: 'Market Intelligence',
    title: 'The Silent Shift: Why Top Executives Are Rethinking Career Longevity',
    excerpt: 'In an era of unprecedented market volatility, the traditional C-suite tenure is evolving. Leaders are increasingly prioritizing roles that offer not just compensation, but sustainable impact and governance influence.'
  }, {
    icon: Compass,
    category: 'Career Strategy',
    title: 'Beyond the Board Room: Emerging Pathways for Senior Leaders',
    excerpt: 'As the definition of corporate leadership expands, fractional executive roles and advisory board positions are becoming the preferred vehicle for high-impact careers.'
  }, {
    icon: Shield,
    category: 'Executive Transitions',
    title: 'The Art of the Quiet Transition: Managing Career Moves with Discretion',
    excerpt: 'Navigating a departure while maintaining leverage requires a delicate balance of transparency and strategy. We explore the protocols of the confidential exit.'
  }];
  return <Section background="warm" id="insights" data-id="element-467">
      <FadeIn className="text-center mb-16" data-id="element-468">
        <span className="font-sans text-accent-500 text-xs font-bold uppercase tracking-[0.2em] block mb-4" data-id="element-469">
          Strategic Perspectives
        </span>
        <h2 className="text-3xl md:text-5xl font-serif text-ink-900 mb-6" data-id="element-470">
          Executive Trends & Insights
        </h2>
        <p className="font-sans text-lg text-body max-w-2xl mx-auto leading-relaxed" data-id="element-471">
          Curated intelligence to help senior leaders navigate the evolving
          landscape of executive careers.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-472">
        {articles.map((article, index) => <FadeIn key={index} delay={index * 0.1} className="group cursor-pointer" data-id="element-473">
            <div className="bg-white h-full p-8 border border-sage-200 hover:border-accent-400/40 transition-all duration-300 hover:shadow-lg relative overflow-hidden" data-id="element-474">
              {/* Decorative number */}
              <div className="absolute top-4 right-6 text-7xl font-serif font-bold text-sage-100 select-none group-hover:text-sage-200/50 transition-colors" data-id="element-475">
                0{index + 1}
              </div>

              {/* Category with icon */}
              <div className="relative z-10 flex items-center gap-2 mb-6" data-id="element-476">
                <article.icon className="w-4 h-4 text-accent-500" data-id="element-477" />
                <span className="font-sans text-xs font-bold uppercase tracking-widest text-accent-500" data-id="element-478">
                  {article.category}
                </span>
              </div>

              <h3 className="relative z-10 text-xl font-serif font-bold text-ink-900 mb-4 group-hover:text-accent-500 transition-colors leading-snug" data-id="element-479">
                {article.title}
              </h3>

              <p className="relative z-10 font-sans text-body-muted leading-relaxed mb-8" data-id="element-480">
                {article.excerpt}
              </p>

              <div className="relative z-10 pt-6 border-t border-sage-100" data-id="element-481">
                <span className="font-sans text-sm font-bold uppercase tracking-widest text-accent-500 flex items-center gap-2 group-hover:translate-x-2 transition-transform" data-id="element-482">
                  Read Insight <ArrowRight className="w-4 h-4" data-id="element-483" />
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}